// extracted by mini-css-extract-plugin
module.exports = {"root":"_3NhYT","large":"_1Wqxl"};